import { documentObjectIconMap } from "Common/dictionaries/documentObjectIconId";
import classNames from "classnames";
import React from "react";
const SIZES = {
    ICON_SIZE: 16
};
export default function DocumentObjectTypeIcon(props) {
    const imgSrc = props.documentObjectIconId
        ? documentObjectIconMap[props.documentObjectIconId]
        : undefined;
    if (imgSrc)
        return (React.createElement("img", { src: imgSrc, alt: "", title: props.documentObjectName || "", height: SIZES.ICON_SIZE, className: classNames("img-cover", props.className) }));
    if (props.showEmptyBlockIfNoIcon)
        return React.createElement("div", { className: props.className });
    return null;
}
